const prefix = '';

export const urls = {

  baseUrl: window.location.protocol + '//' + window.location.host,

  cabinet: {

    urlGetArmario: prefix + '/Armario/GetArmario',
    urlGetArmarios: prefix + '/Armario/GetArmarios',
    urlGetCreateFolder: prefix + '/Armario/GetCreateFolder',
    urlCreateFolder: prefix + '/Armario/CreateFolder',
    urlGetCreate: prefix + '/Armario/GetCreate',
    urlCreate: prefix + '/Armario/Create',
    urlDelete: prefix + '/Armario/Delete',
    urlGetRename: prefix + '/Armario/GetRename',
    urlRename: prefix + '/Armario/Rename',
    urlGetManagerRoles: prefix + '/Armario/GetManagerRoles',
    urlManagerRoles: prefix + '/Armario/ManagerRoles',
    urlGetObjectRoles: prefix + '/Armario/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Armario/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Armario/GetProperties',
    urlGetPermissions: prefix + '/Armario/GetPermissions',
    urlGetHistory: prefix + '/Armario/GetHistory',
    urlGetAuditAccess: prefix + '/Armario/GetAuditAccess',
  },

  folder: {

    urlGetCreate: prefix + '/Pasta/GetCreate',
    urlCreate: prefix + '/Pasta/Create',
    urlGetRename: prefix + '/Pasta/GetRename',
    urlRename: prefix + '/Pasta/Rename',
    urlGetDelete: prefix + '/Pasta/GetDelete',
    urlDelete: prefix + '/Pasta/Delete',
    urlGetManagerRoles: prefix + '/Pasta/GetManagerRoles',
    urlManagerRoles: prefix + '/Pasta/ManagerRoles',
    urlGetObjectRoles: prefix + '/Pasta/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Pasta/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Pasta/GetProperties',
    urlGetPermissions: prefix + '/Pasta/GetPermissions',
    urlGetDocumentsForSignInFolder: prefix + '/Pasta/GetDocumentsForSignInFolder',
    urlGetAttribForm: prefix + '/Pasta/GetAttribForm',
    urlAttribFormDataDocuments: prefix + '/Pasta/AttribFormDataDocuments',
    urlAttribFormData: prefix + '/Pasta/AttribFormData',
    urlGetFormData: prefix + '/Pasta/GetFormData',
    urlProcessOCR: prefix + '/Pasta/ProcessOCR',
    urlGetName: prefix + '/Pasta/GetName',
    urlGetCopyTo: prefix + '/Pasta/GetCopyTo',
    urlGetCopyToDragAndDrop: prefix + '/Pasta/GetCopyToDragAndDrop',
    urlCopyTo: prefix + '/Pasta/CopyTo',
    urlGetCopyToWardrobeDragAndDrop: prefix + '/Pasta/GetCopyToWardrobeDragAndDrop',
    urlCopyToWardrobe: prefix + '/Pasta/CopyToWardrobe',
    urlGetMoveTo: prefix + '/Pasta/GetMoveTo',
    urlGetMoveToDragAndDrop: prefix + '/Pasta/GetMoveToDragAndDrop',
    urlMoveTo: prefix + '/Pasta/MoveTo',
    urlGetMoveToWardrobeDragAndDrop: prefix + '/Pasta/GetMoveToWardrobeDragAndDrop',
    urlMoveToWardrobe: prefix + '/Pasta/MoveToWardrobe',
    urlGetSign: prefix + '/Pasta/GetSign',
    urlGetHistory: prefix + '/Pasta/GetHistory',
    urlGetPropertiesDocsWithotPages: prefix + '/Pasta/GetPropertiesDocsWithotPages',
    urlGetProcessOCR: prefix + '/Pasta/GetProcessOCR',
    urlGetPastaMonitorEmailConfigs: prefix + '/Pasta/GetPastaMonitorEmailConfigs',
    urlGetPropertiesDocsMonitor: prefix + '/Pasta/GetPropertiesDocsMonitor',
    urlDeletePastaMonitorEmail: prefix + '/Pasta/DeletePastaMonitorEmail',
    urlCreatePastaMonitorEmail: prefix + '/Pasta/CreatePastaMonitorEmail',
    urlUnlockDocuments: prefix + '/Pasta/UnlockDocuments',
    urlGetTreePath: prefix + '/Pasta/GetTreePath',
    urlGetAuditAccess: prefix + '/Pasta/GetAuditAccess',
    urlGetMoveToMultiple: prefix + '/Pasta/GetMoveToMultiple',
    urlGetTreePathById: prefix + '/Pasta/GetTreePathById',
    urlGetCopyToMultiple: prefix + '/Pasta/GetCopyToMultiple',
    urlGetProcessOCRMultiple: prefix + '/Pasta/GetProcessOCRMultiple',
    urlProcessOCRMultiple: prefix + '/Pasta/ProcessOCRMultiple',
    urlGetMergeToMultiple: prefix + '/Pasta/GetMergeToMultiple',
    urlMergeToMultiple: prefix + '/Pasta/MergeToMultiple',
    urlGetMoveToMultipleSearch: prefix + '/Pasta/GetMoveToMultipleSearch',
    urlGetCopyToMultipleSearch: prefix + '/Pasta/GetCopyToMultipleSearch',
    urlGetVirtualPath: prefix + '/Pasta/GetVirtualPath',
    urlGetCertificateType: prefix + '/Pasta/GetCertificateType',

  },

  document: {

    urlGetRename: prefix + '/Documento/GetRename',
    urlRename: prefix + '/Documento/Rename',
    urlDelete: prefix + '/Documento/Delete',
    urlGetExport: prefix + '/Documento/GetExport',
    urlExport: prefix + '/Documento/Export',
    urlGetManagerRoles: prefix + '/Documento/GetManagerRoles',
    urlGetObjectRoles: prefix + '/Documento/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Documento/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Documento/GetProperties',
    urlGetCopyTo: prefix + '/Documento/GetCopyTo',
    urlCopyTo: prefix + '/Documento/CopyTo',
    urlGetImportTo: prefix + '/Documento/GetImportTo',
    urlGetPrintablePages: prefix + '/Documento/GetPrintablePages',
    urlUnblock: prefix + '/Documento/Unblock',
    urlProcessOCR: prefix + '/Documento/ProcessOCR',
    urlGetDocumentThumb: prefix + '/Documento/GetDocumentThumb',
    urlGetPermissions: prefix + '/Documento/GetPermissions',
    urlGetPermissionsExtend: prefix + '/Documento/GetPermissionsExtend',
    urlGetTrechosOCR: prefix + '/Documento/GetTrechosOCR',
    urlGetViewSummary: prefix + '/Documento/GetViewSummary',
    urlGetFormData: prefix + '/Documento/GetFormData',
    urlGetCreate: prefix + '/Documento/GetCreate',
    urlCreate: prefix + '/Documento/Create',
    urlGetDocumento: prefix + '/Documento/GetDocumento',
    urlManagerRoles: prefix + '/Documento/ManagerRoles',
    urlGetEditForm: prefix + '/Documento/GetEditForm',
    urlEditForm: prefix + '/Documento/EditForm',
    urlGetPrintForm: prefix + '/Documento/GetPrintForm',
    urlGetPrintFormData: prefix + '/Documento/GetPrintFormData',
    urlGetReplace: prefix + '/Documento/GetReplace',
    urlGetCopyToDragAndDrop: prefix + '/Documento/GetCopyToDragAndDrop',
    urlGetMoveTo: prefix + '/Documento/GetMoveTo',
    urlGetMoveToDragAndDrop: prefix + '/Documento/GetMoveToDragAndDrop',
    urlMoveTo: prefix + '/Documento/MoveTo',
    urlGetTemporalidade: prefix + '/Documento/GetTemporalidade',
    urlTemporalidade: prefix + '/Documento/Temporalidade',
    urlGetSign: prefix + '/Documento/GetSign',
    urlStartSign: prefix + '/Documento/StartSign',
    urlFinishSign: prefix + '/Documento/FinishSign',
    urlRemoveSign: prefix + '/Documento/RemoveSign',
    urlGetMarcaDagua: prefix + '/Documento/GetMarcaDagua',
    urlMarcaDagua: prefix + '/Documento/MarcaDagua',
    urlGetCreateFromPageClassify: prefix + '/Documento/GetCreateFromPageClassify',
    urlMovePagesToDocument: prefix + '/Documento/MovePagesToDocument',
    urlCopyPagesToDocument: prefix + '/Documento/CopyPagesToDocument',
    urlGetCopyMoveFromPageClassify: prefix + '/Documento/GetCopyMoveFromPageClassify',
    urlGetHistory: prefix + '/Documento/GetHistory',
    urlGetShare: prefix + '/Documento/GetShare',
    urlShare: prefix + '/Documento/Share',
    urlDeleteShare: prefix + '/Documento/DeleteShare',
    urlGetTotalPages: prefix + '/Documento/GetTotalPages',
    urlGetProcessOCR: prefix + '/Documento/GetProcessOCR',
    urlGetTreePath: prefix + '/Documento/GetTreePath',
    urlMergeTo: prefix + '/Documento/MergeTo',
    urlGetAuditAccess: prefix + '/Documento/GetAuditAccess',
    urlSplitPDF: prefix + '/Documento/SplitPDF',
    urlProcessOCRMultiple: prefix + '/Documento/ProcessOCRMultiple',
    urlGetSignMultiple: prefix + '/Documento/GetSignMultiple',
    urlGetTemporalidadeMultiple: prefix + '/Documento/GetTemporalidadeMultiple',
    urlTemporalidadeMultiple: prefix + '/Documento/TemporalidadeMultiple',
    urlGetMergeToMultiple: prefix + '/Documento/GetMergeToMultiple',
    urlGetEditFormMultiple: prefix + '/Documento/GetEditFormMultiple',
    urlEditFormMultiple: prefix + '/Documento/EditFormMultiple',
    urlCreateByProfileAsync: prefix + '/Documento/CreateByProfile',
    urlCreateByFolderIdAsync: prefix + '/Documento/CreateByFolderId',
    urlImportToAsync: prefix + '/Documento/ImportTo',
    urlGetWebTreePath: prefix + '/Documento/GetWebTreePath',
    urlCreateFromClassifyAsync: prefix + '/Documento/CreateFromClassify',
    urlGetConvertDocument: prefix + '/Documento/GetConvertDocument',
    urlConvertDocument: prefix + '/Documento/ConvertDocument',
    urlGetEditFormMultipleSearch: prefix + '/Documento/GetEditFormMultipleSearch',
    urlGetCreateMultiple: prefix + '/Documento/GetCreateMultiple',
    urlGetCertificateManifestOptions: prefix + '/Documento/GetCertificateManifestOptions',
    urlGetCertificateManifest: prefix + '/Documento/GetCertificateManifest',
    urlCreateDocRequestByProfileAsync: prefix + '/Documento/CreateDocRequestByProfile',

    urlGetCertificateType: prefix + '/Documento/GetCertificateType',
    // urlGetCertificatesLiquidSuiteManagement: prefix + '/Documento/GetCertificatesLiquidSuiteManagement',
    urlGetCertificateTypeMultipleDocs: prefix + '/Documento/GetCertificateTypeMultipleDocs',

    urlGetPrintDocument: prefix + '/Documento/GetPrintDocument',
    urlGetPrintDocumentFile: prefix + '/Documento/GetPrintDocumentFile',
    
    
  },

  images: {

    urlLogoLiquidSuiteMedio: prefix + '/images/logotipo_med.png',
    urlLogoLiquidSuite: prefix + '/images/logotipo_pequeno.png',
    urlInfoIcon: prefix + '/images/ic_info_white_24px.svg',
    urlMisteryMan: prefix + '/images/mistery-man.png',
    urlMisteryMan120: prefix + '/images/mistery-man-120.png'

  },

  home: {

    urlIndex: prefix
  },

  jsTree: {
    urlGetRoots: prefix + '/Tree/GetTree',
    urlGetWardrobe: prefix + '/Tree/GetTreeArmario',
    urlGetFolder: prefix + '/Tree/GetTreePasta'
  },

  grid: {
    urlGetGridWardrobePrincipal: prefix + '/Grid/GetGridTableWardrobePrincipal',
    urlGetGridFolderPrincipal: prefix + '/Grid/GetGridTableFolderPrincipal',
    urlGetGridTableFichaSearch: prefix + '/Grid/GetGridTableFichaSearch',
    urlGetGridTableDocumentoSearch: prefix + '/Grid/GetGridTableDocumentoSearch',
    urlGetGridTableOCRSearch: prefix + '/Grid/GetGridTableOCRSearch',
    urlExportFromFichaSearch: prefix + '/Grid/ExportFromFichaSearch',
    urlGetExportOptions: prefix + '/Grid/GetExportOptions',
    urlGetFichaSearchReportOptions: prefix + '/Grid/GetFichaSearchReportOptions',
    urlGetFichaSearchReport: prefix + '/Grid/GetFichaSearchReport',
    urlGetDocumentSearchReportOptions: prefix + '/Grid/GetDocumentSearchReportOptions',
    urlGetDocumentSearchReport: prefix + '/Grid/GetDocumentSearchReport',
    urlGetOCRSearchReportOptions: prefix + '/Grid/GetOCRSearchReportOptions',
    urlGetOCRSearchReport: prefix + '/Grid/GetOCRSearchReport',
    urlGetExportOptionsSelectedDocs: prefix + '/Grid/GetExportOptionsSelectedDocs',
    urlExportSelectedDocuments: prefix + '/Grid/ExportSelectedDocuments',
  },

  language: {
    urlLanguage: prefix + '/js/lang.'
  },

  page: {

    urlGetOCR: prefix + '/Pagina/GetOCR',
    urlGetPageFileName: prefix + '/Pagina/GetPageFileName',
    urlUploadFile: prefix + '/Pagina/UploadFile',
    urlProcessOCR: prefix + '/Pagina/ProcessOCR',
    urlSaveOCR: prefix + '/Pagina/SaveOCR',
    urlGetMovePage: prefix + '/Pagina/GetMovePage',
    urlMovePage: prefix + '/Pagina/MovePage',
    urlDelete: prefix + '/Pagina/Delete',
    urlGetBase64ForSign: prefix + '/Pagina/GetBase64ForSign',
    urlSaveSignature: prefix + '/Pagina/SaveSignature',
    urlRotatePage: prefix + '/Pagina/RotatePage',
    urlGetPageFile: prefix + '/Pagina/GetPageFile',
    urlGetPageThumb: prefix + '/Pagina/GetPageThumb',
    urlGetAnnotation: prefix + '/Pagina/GetAnnotation',
    urlGetCreateAnnotation: prefix + '/Pagina/GetCreateAnnotation',
    urlCreateAnnotation: prefix + '/Pagina/CreateAnnotation',
    urlDeleteAnnotation: prefix + '/Pagina/DeleteAnnotation',
    urlSaveMarcacao: prefix + '/Pagina/SaveMarcacao',
    urlRemoveMarcacao: prefix + '/Pagina/RemoveMarcacao',
    urlGetMarcacoes: prefix + '/Pagina/GetMarcacoes',
    urlCanViewWithouMarcacao: prefix + '/Pagina/CanViewWithouMarcacao',
    urlGetBigThumb: prefix + '/Pagina/GetBigThumb',
    urlLogActivityDownload: prefix + '/Pagina/LogActivityDownload',
    urlLogActivityPrint: prefix + '/Pagina/LogActivityPrint',
    urlGetPageFileOfficePre: prefix + '/Pagina/GetPageFileOfficePre',
    urlGetPageFileOffice: prefix + '/Pagina/GetPageFileOffice',

    urlGetViewData: prefix + '/Pagina/GetViewData',
    urlGetPageFileXmlContentPretty: prefix + '/Pagina/GetPageFileXmlContentPretty',
    urlConvertPageAsPDFFile: prefix + '/Pagina/ConvertPageAsPDFFile',

  },

  user: {

    urlGetUserName: prefix + '/Usuario/GetUserName',
    urlGetGravatarUrl: prefix + '/Usuario/GetGravatarUrl',
    urlLogout: prefix + '/Login/LogOut',
    urlGetUsuario: prefix + '/Usuario/GetUsuario',
    urlGetUsuarios: prefix + '/Usuario/GetUsuarios',
    urlGetObjectRoles: prefix + '/Usuario/GetObjectRoles',
    urlGetSystemRoles: prefix + '/Usuario/GetSystemRoles',
    urlGetCreate: prefix + '/Usuario/GetCreate',
    urlCreate: prefix + '/Usuario/Create',
    urlGetEdit: prefix + '/Usuario/GetEdit',
    urlEdit: prefix + '/Usuario/Edit',
    urlDelete: prefix + '/Usuario/Delete',
    urlGetManagerRoles: prefix + '/Usuario/GetManagerRoles',
    urlManagerRoles: prefix + '/Usuario/ManagerRoles',
    urlGetManagerSystemRoles: prefix + '/Usuario/GetManagerSystemRoles',
    urlManagerSystemRoles: prefix + '/Usuario/ManagerSystemRoles',
    urlGetUsuariosForReports: prefix + '/Usuario/GetUsuariosForReports',
    urlGetSystemPermission: prefix + '/Usuario/GetSystemPermission',
    urlGetUpdatePassword: prefix + '/Usuario/GetUpdatePassword',
    urlUpdatePassword: prefix + '/Usuario/UpdatePassword',
    urlGetEditPerfil: prefix + '/Usuario/GetEditPerfil',
    urlEditPerfil: prefix + '/Usuario/EditPerfil',
    urlUploadFile: prefix + '/Usuario/UploadFile',
    urlGetImagemPerfil: prefix + '/Usuario/GetImagemPerfil',
    urlUpdateResetPassword: prefix + '/Usuario/UpdateResetPassword',
    urlGetActiveSessions: prefix + '/Usuario/GetActiveSessions',
    urlGetActiveSessionDetails: prefix + '/Usuario/GetActiveSessionDetails',
    urlDeleteActiveSession: prefix + '/Usuario/DeleteActiveSession',
    urlGetCreateNotification: prefix + '/Usuario/GetCreateNotification',
    urlGetMessages: prefix + '/Usuario/GetMessages',
    urlCreateNotification: prefix + '/Usuario/CreateNotification',
    urlMarkMensagemAsRead: prefix + '/Usuario/MarkMensagemAsRead',
    urlRemoveMessages: prefix + '/Usuario/RemoveMessages',
    urlGetNewMessages: prefix + '/Usuario/GetNewMessages',
    urlGetHistory: prefix + '/Usuario/GetHistory',
    urlGetConfigureRootFolder: prefix + '/Usuario/GetConfigureRootFolder',
    urlConfigureRootFolder: prefix + '/Usuario/ConfigureRootFolder',
    urlGetUserProfile: prefix + '/Usuario/GetUserProfile',
    urlGetConfigAllowedApp: prefix + '/Usuario/GetConfigAllowedApp',
    urlConfigAllowedApp: prefix + '/Usuario/ConfigAllowedApp',
    urlLogOutExpiredSession: prefix + '/Login/LogOutExpiredSession',
    urlCheckStatus: prefix + '/Login/CheckStatus',

  },

  search: {

    urlGetSearch: prefix + '/Search/GetSearch'

  },

  report: {

    urlGetReportAtividades: prefix + '/Report/GetReportAtividades',
    urlReportAtividades: prefix + '/Report/ReportAtividades',
    urlGetTotalUsersOnline: prefix + '/Report/GetTotalUsersOnline',
    urlGetLastDocsAdd: prefix + '/Report/GetLastDocsAdd',
    urlGetLastPagesAdd: prefix + '/Report/GetLastPagesAdd',
    urlGetLastPagesViews: prefix + '/Report/GetLastPagesViews',
    urlGetVolumesInfo: prefix + '/Report/GetVolumesInfo',
    urlGetDatabaseSizeInfo: prefix + '/Report/GetDatabaseSizeInfo',
    urlGetFichasInfo: prefix + '/Report/GetFichasInfo',
    urlGetSystemInfoReport: prefix + '/Report/GetSystemInfoReport',
    urlGetReportError: prefix + '/Report/GetReportError',
    urlGetErrorDetail: prefix + '/Report/GetErrorDetail',
    urlGetActivityDetail: prefix + '/Report/GetActivityDetail',
    urlGetGridReportErrorForPrint: prefix + '/Report/GetGridReportErrorForPrint',
    urlGetPrintError: prefix + '/Report/GetPrintError',
    urlClearAll: prefix + '/Report/ClearAll',
    urlGetPrintActivities: prefix + '/Report/GetPrintActivities',
    urlReportAtividadesForPrint: prefix + '/Report/ReportAtividadesForPrint',
    urlGetReportProcessOCR: prefix + '/Report/GetReportProcessOCR',
    urlGetReportProcessOCRDetail: prefix + '/Report/GetReportProcessOCRDetail',
    urlCancelProcessOCRSchedule: prefix + '/Report/CancelProcessOCRSchedule',
    urlGetGridDocumentsExpired: prefix + '/Report/GetGridDocumentsExpired',
    urlGetGridDocumentsToExpire: prefix + '/Report/GetGridDocumentsToExpire',
    urlGetPrintTemporalidadeReport: prefix + '/Report/GetPrintTemporalidadeReport',
    urlGetGridUserGroupRules: prefix + '/Report/GetGridUserGroupRules',
    urlGetPrintUserGroupRulesReport: prefix + '/Report/GetPrintUserGroupRulesReport',
    urlGetProductionReport: prefix + '/Report/GetProductionReport',
    urlGetViewReportProduction: prefix + '/Report/GetViewReportProduction',
    urlGetPrintProductionReport: prefix + '/Report/GetPrintProductionReport',
    urlGetViewDocumentAccessReport: prefix + '/Report/GetViewDocumentAccessReport',
    urlGetDocumentAccessReport: prefix + '/Report/GetDocumentAccessReport',
    urlGetPrintDocAccessReport: prefix + '/Report/GetPrintDocAccessReport',

  },

  form: {

    urlGetFichas: prefix + '/Ficha/GetFichas',
    urlGetFichasWithCampos: prefix + '/Ficha/GetFichasWithCampos',
    urlGetCreate: prefix + '/Ficha/GetCreate',
    urlCreate: prefix + '/Ficha/Create',
    urlGetEdit: prefix + '/Ficha/GetEdit',
    urlEdit: prefix + '/Ficha/Edit',
    urlDelete: prefix + '/Ficha/Delete',
    urlGetObjectRoles: prefix + '/Ficha/GetObjectRoles',
    urlGetManagerRoles: prefix + '/Ficha/GetManagerRoles',
    urlManagerRoles: prefix + '/Ficha/ManagerRoles',
    urlGetCamposByFicha: prefix + '/Ficha/GetCamposByFicha',
    urlGetCampoCreate: prefix + '/Ficha/GetCampoCreate',
    urlCampoCreate: prefix + '/Ficha/CampoCreate',
    urlGetCampoEdit: prefix + '/Ficha/GetCampoEdit',
    urlCampoEdit: prefix + '/Ficha/CampoEdit',
    urlCampoDelete: prefix + '/Ficha/CampoDelete',
    urlGetConfigIndexDesktop: prefix + '/Ficha/GetConfigIndexDesktop',
    urlConfigIndexDesktop: prefix + '/Ficha/ConfigIndexDesktop',
    urlGetTemporalidade: prefix + '/Ficha/GetTemporalidade',
    urlTemporalidade: prefix + '/Ficha/Temporalidade',
    urlGetHistory: prefix + '/Ficha/GetHistory',
    urlGetFichasForReports: prefix + '/Ficha/GetFichasForReports',
    urlGetCamposByFichaDocRequest: prefix + '/Ficha/GetCamposByFichaDocRequest',
    urlCloneForm: prefix + '/Ficha/CloneForm',
  },

  importProfile: {

    urlGetPerfisImportacao: prefix + '/PerfilImportacao/GetPerfisImportacao',
    urlGetCreate: prefix + '/PerfilImportacao/GetCreate',
    urlCreate: prefix + '/PerfilImportacao/Create',
    urlGetEdit: prefix + '/PerfilImportacao/GetEdit',
    urlEdit: prefix + '/PerfilImportacao/Edit',
    urlDelete: prefix + '/PerfilImportacao/Delete',

    urlGetHistory: prefix + '/PerfilImportacao/GetHistory'

  },

  volume: {

    urlGetVolume: prefix + '/Volume/GetVolume',
    urlGetVolumes: prefix + '/Volume/GetVolumes',
    urlGetCreate: prefix + '/Volume/GetCreate',
    urlCreate: prefix + '/Volume/Create',
    urlCreateGoogleDrive: prefix + '/Volume/CreateGoogleDrive',
    urlGetEdit: prefix + '/Volume/GetEdit',
    urlEdit: prefix + '/Volume/Edit',
    urlDelete: prefix + '/Volume/Delete',
    urlGetHistory: prefix + '/Volume/GetHistory',
    urlGetUpdateCredentials: prefix + '/Volume/GetUpdateCredentials',
    urlUpdateCredentials: prefix + '/Volume/UpdateCredentials',
    urlGetVolumeInfo: prefix + '/Volume/GetVolumeInfo',
    urlSetDefault: prefix + '/Volume/SetDefault',

  },

  group: {

    urlGetGrupo: prefix + '/Grupo/GetGrupo',
    urlGetGrupos: prefix + '/Grupo/GetGrupos',
    urlGetCreate: prefix + '/Grupo/GetCreate',
    urlCreate: prefix + '/Grupo/Create',
    urlGetEdit: prefix + '/Grupo/GetEdit',
    urlEdit: prefix + '/Grupo/Edit',
    urlDelete: prefix + '/Grupo/Delete',
    urlGetManagerRoles: prefix + '/Grupo/GetManagerRoles',
    urlManagerRoles: prefix + '/Grupo/ManagerRoles',
    urlGetObjectRoles: prefix + '/Grupo/GetObjectRoles',
    urlGetSystemRoles: prefix + '/Grupo/GetSystemRoles',
    urlGetManagerSystemRoles: prefix + '/Grupo/GetManagerSystemRoles',
    urlManagerSystemRoles: prefix + '/Grupo/ManagerSystemRoles',
    urlGetUsuarios: prefix + '/Grupo/GetUsuarios',
    urlGetUsuariosView: prefix + '/Grupo/GetUsuariosView',
    urlGetHistory: prefix + '/Grupo/GetHistory',
    urlGetConfigAllowedApp: prefix + '/Grupo/GetConfigAllowedApp',
    urlConfigAllowedApp: prefix + '/Grupo/ConfigAllowedApp',
    urlGetGruposForReports: prefix + '/Grupo/GetGruposForReports',
  },

  objectRule: {

    urlGetObjectRoles: prefix + '/ObjectRole/GetObjectRoles',
    urlGetObjectRole: prefix + '/ObjectRole/GetObjectRole',
    urlGetCreate: prefix + '/ObjectRole/GetCreate',
    urlCreate: prefix + '/ObjectRole/Create',
    urlGetEdit: prefix + '/ObjectRole/GetEdit',
    urlEdit: prefix + '/ObjectRole/Edit',
    urlDelete: prefix + '/ObjectRole/Delete',
    urlGetHistory: prefix + '/ObjectRole/GetHistory'

  },

  systemRule: {

    urlGetSystemRoles: prefix + '/SystemRole/GetSystemRoles',
    urlGetSystemRole: prefix + '/SystemRole/GetSystemRole',
    urlGetCreate: prefix + '/SystemRole/GetCreate',
    urlCreate: prefix + '/SystemRole/Create',
    urlGetEdit: prefix + '/SystemRole/GetEdit',
    urlEdit: prefix + '/SystemRole/Edit',
    urlDelete: prefix + '/SystemRole/Delete',
    urlGetCanAccessManager: prefix + '/SystemRole/GetCanAccessManager',
    urlGetCanSearch: prefix + '/SystemRole/GetCanSearch',
    urlGetCanAccessReports: prefix + '/SystemRole/GetCanAccessReports',
    urlGetHistory: prefix + '/SystemRole/GetHistory'

  },

  logImportacao: {

    urlGetGuid: prefix + '/LogImportacao/GetGuid'
  },

  css: {

    urlBootstrapCss: prefix + '/lib/bootstrap/dist/css/bootstrap.min.css',
    urlRobotoFontCss: 'https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i'
  },

  connection: {

    urlGetConexao: prefix + '/Conexao/GetConexao',
    urlGetConexoes: prefix + '/Conexao/GetConexoes',
    urlGetCreate: prefix + '/Conexao/GetCreate',
    urlCreate: prefix + '/Conexao/Create',
    urlGetEdit: prefix + '/Conexao/GetEdit',
    urlEdit: prefix + '/Conexao/Edit',
    urlDelete: prefix + '/Conexao/Delete',
    urlGetHistory: prefix + '/Conexao/GetHistory'
  },

  query: {

    urlGetQueries: prefix + '/Query/GetQueries',
    urlGetCreate: prefix + '/Query/GetCreate',
    urlCreate: prefix + '/Query/Create',
    urlGetEdit: prefix + '/Query/GetEdit',
    urlEdit: prefix + '/Query/Edit',
    urlDelete: prefix + '/Query/Delete',
    urlGetHistory: prefix + '/Query/GetHistory'
  },

  integration: {

    urlGetIntegracao: prefix + '/Integracao/GetIntegracao',
    urlGetIntegracoes: prefix + '/Integracao/GetIntegracoes',
    urlGetCreate: prefix + '/Integracao/GetCreate',
    urlCreate: prefix + '/Integracao/Create',
    urlGetEdit: prefix + '/Integracao/GetEdit',
    urlEdit: prefix + '/Integracao/Edit',
    urlDelete: prefix + '/Integracao/Delete',

    urlCallIntegracao: prefix + '/Integracao/CallIntegracao',
    urlGetHistory: prefix + '/Integracao/GetHistory'
  },

  indexador: {

    urlGetDynamicWebTwain: prefix + '/Indexador/GetDynamicWebTwain',
    urlGetCreate: prefix + '/Indexador/GetCreate',
    urlUploadProcess: prefix + '/Indexador/UploadProcess',
    urlUploadFile: prefix + '/Indexador/UploadFile',
    urlImportProcess: prefix + '/Indexador/ImportProcess',
    urlGetIsLicenced: prefix + '/Indexador/GetIsLicenced'
  },

  authApplication: {

    urlGetAuthApplications: prefix + '/AuthApplication/GetAuthApplications',
    urlGetAuthApplication: prefix + '/AuthApplication/GetAuthApplication',
    urlGetCreate: prefix + '/AuthApplication/GetCreate',
    urlCreate: prefix + '/AuthApplication/Create',
    urlGetEdit: prefix + '/AuthApplication/GetEdit',
    urlEdit: prefix + '/AuthApplication/Edit',
    urlDelete: prefix + '/AuthApplication/Delete',
    urlGetHistory: prefix + '/AuthApplication/GetHistory',
    urlGetGroupUserAllowed: prefix + '/AuthApplication/GetGroupUserAllowed',
    urlGroupUserAllowed: prefix + '/AuthApplication/GroupUserAllowed',
  },

  configurador: {

    urlGetLiquidSuiteEmailConfig: prefix + '/Configurador/GetLiquidSuiteEmailConfig',
    urlEditLiquidSuiteEmailConfig: prefix + '/Configurador/EditLiquidSuiteEmailConfig',

    urlGetLiquidSuiteSecurityConfig: prefix + '/Configurador/GetLiquidSuiteSecurityConfig',
    urlEditLiquidSuiteSecurityConfig: prefix + '/Configurador/EditLiquidSuiteSecurityConfig',

    urlGetConfigLiquidSuite: prefix + '/Configurador/GetConfigLiquidSuite',
    //urlGetEditLiquidSuiteConfig: prefix + '/Configurador/GetEditLiquidSuiteConfig',
    //urlEditLiquidSuiteConfig: prefix + '/Configurador/EditLiquidSuiteConfig',
    //urlGetConfigTemporalidade: prefix + '/Configurador/GetConfigTemporalidade',
    //urlStartTemporalidadeService: prefix + '/Configurador/StartTemporalidadeService',
    //urlStopTemporalidadeService: prefix + '/Configurador/StopTemporalidadeService',
    urlGetHistory: prefix + '/Configurador/GetHistory',
    //urlGetConfigActiveDirectory: prefix + '/Configurador/GetConfigActiveDirectory',
    urlGetUsersActiveDirectory: prefix + '/Configurador/GetUsersActiveDirectory',
    urlImportUsersActiveDirectory: prefix + '/Configurador/ImportUsersActiveDirectory',
    //urlEditConfigActiveDirectory: prefix + '/Configurador/EditConfigActiveDirectory',
    urlGetConfigCertification: prefix + '/Configurador/GetConfigCertification',
    urlEditConfigCertification: prefix + '/Configurador/EditConfigCertification',

    urlGetViewLDAPConfigurations: prefix + '/Configurador/GetViewLDAPConfigurations',
    urlGetViewLDAPConfiguration: prefix + '/Configurador/GetViewLDAPConfiguration',
    urlEditLDAPConfiguration: prefix + '/Configurador/EditLDAPConfiguration',
    urlGetViewNewLDAPConfiguration: prefix + '/Configurador/GetViewNewLDAPConfiguration',
    urlCreateLDAPConfiguration: prefix + '/Configurador/CreateLDAPConfiguration',
    urlDeleteLDAPConfiguration: prefix + '/Configurador/DeleteLDAPConfiguration',

  },

  watermark: {

    urlGetMarcaDagua: prefix + '/MarcaDagua/GetMarcaDagua',
    urlGetMarcasDagua: prefix + '/MarcaDagua/GetMarcasDagua',
    urlGetCreate: prefix + '/MarcaDagua/GetCreate',
    urlCreate: prefix + '/MarcaDagua/Create',
    urlGetEdit: prefix + '/MarcaDagua/GetEdit',
    urlEdit: prefix + '/MarcaDagua/Edit',
    urlDelete: prefix + '/MarcaDagua/Delete',
    urlGetHistory: prefix + '/MarcaDagua/GetHistory'
  },

  helper: {

    urlGetVideos: prefix + '/Helper/GetVideos'

  },

  field: {

    urlGetAutoFill: prefix + '/Campo/GetAutoFill',
    urlAutoFill: prefix + '/Campo/AutoFill',
    urlGetFormatFrontEnd: prefix + '/Campo/GetFormatFrontEnd',
    urlFormatFrontEnd: prefix + '/Campo/FormatFrontEnd',
    urlGetFormatBackEnd: prefix + '/Campo/GetFormatBackEnd',
    urlFormatBackEnd: prefix + '/Campo/FormatBackEnd',

    urlGetActiveIntegracao: prefix + '/Campo/GetActiveIntegracao',
    urlActiveIntegracao: prefix + '/Campo/ActiveIntegracao',
    urlRemoveIntegracao: prefix + '/Campo/RemoveIntegracao',

    urlGetIndexacaoCampo: prefix + '/Campo/GetIndexacaoCampo',
    urlIndexacaoCampo: prefix + '/Campo/IndexacaoCampo',

  },

  license: {

    urlGetEdit: prefix + '/Licenses/GetEdit',
    urlEdit: prefix + '/Licenses/Edit',
    urlGetClassifyDocumentEnabled: prefix + '/Licenses/GetClassifyDocumentEnabled',
    urlGetLicenseLiquid: prefix + '/Licenses/GetLicenseLiquid',

  },

  queryAPI: {

    urlGetAll: prefix + '/QuerysAPI/GetAll',
    urlGetCreate: prefix + '/QuerysAPI/GetCreate',
    urlCreate: prefix + '/QuerysAPI/Create',
    urlGetEdit: prefix + '/QuerysAPI/GetEdit',
    urlEdit: prefix + '/QuerysAPI/Edit',
    urlDelete: prefix + '/QuerysAPI/Delete'
  },

  integrationAPI: {

    urlGet: prefix + '/IntegracaoAPI/Get',
    urlGetAll: prefix + '/IntegracaoAPI/GetAll',
    urlGetCreate: prefix + '/IntegracaoAPI/GetCreate',
    urlCreate: prefix + '/IntegracaoAPI/Create',
    urlGetEdit: prefix + '/IntegracaoAPI/GetEdit',
    urlEdit: prefix + '/IntegracaoAPI/Edit',
    urlDelete: prefix + '/IntegracaoAPI/Delete',

    urlGetFieldsCondition: prefix + '/IntegracaoAPI/GetFieldsCondition',
    urlCallIntegracao: prefix + '/IntegracaoAPI/CallIntegracao',

  },

  certificates: {

    // urlGetAll: prefix + '/Certificate/GetCertificates',
    //urlGetCreate: prefix + '/Certificate/GetCreate',
    //urlCreate: prefix + '/Certificate/Create',
    //urlGetEdit: prefix + '/Certificate/GetEdit',
    //urlEdit: prefix + '/Certificate/Edit',
    //urlDelete: prefix + '/Certificate/Delete',
    urlGetDocsForSignServer: prefix + '/Certificate/GetDocsForSignServer',
    urlSignDocsServer: prefix + '/Certificate/SignDocsServer',
    urlGetDocsForSignLocal: prefix + '/Certificate/GetDocsForSignLocal',
    urlGetPagesForSignLocal: prefix + '/Certificate/GetPagesForSignLocal',
    urlStartPageSignLocal: prefix + '/Certificate/StartPageSignLocal',
    urlFinishPageSignLocal: prefix + '/Certificate/FinishPageSignLocal',

    urlGetCertificateIdentifier: prefix + '/Certificate/GetCertificateIdentifier',
    urlDiscoverProvider: prefix + '/Certificate/DiscoverProvider',

    urlGetCertificatesLiquidManaged: prefix + '/Certificate/GetCertificatesLiquidManaged',
    urlGetSelectCertificatesLiquidManaged: prefix + '/Certificate/GetSelectCertificatesLiquidManaged',
    urlGetEditLiquidManaged: prefix + '/Certificate/GetEditLiquidManaged',
    urlEditLiquidManaged: prefix + '/Certificate/EditLiquidManaged',
    urlGetEditPasswordLiquidManaged: prefix + '/Certificate/GetEditPasswordLiquidManaged',
    urlEditPasswordLiquidManaged: prefix + '/Certificate/EditPasswordLiquidManaged',
    urlDeleteLiquidManaged: prefix + '/Certificate/DeleteLiquidManaged',

    urlGetCreateLiquidManagedChooseType: prefix + '/Certificate/GetCreateLiquidManagedChooseType',
    urlGetCreateLiquidManagedA1: prefix + '/Certificate/GetCreateLiquidManagedA1',
    urlCreateLiquidManagedA1: prefix + '/Certificate/CreateLiquidManagedA1',
    urlGetCreateLiquidManagedCloud: prefix + '/Certificate/GetCreateLiquidManagedCloud',
    urlCreateLiquidManagedCloud: prefix + '/Certificate/CreateLiquidManagedCloud',
    urlSignDocLiquidManagedCloud: prefix + '/Certificate/SignDocLiquidManagedCloud',
    urlSignMultipleDocsLiquidManagedCloud: prefix + '/Certificate/SignMultipleDocsLiquidManagedCloud',
    urlSignFolderLiquidManagedCloud: prefix + '/Certificate/SignFolderLiquidManagedCloud',
    urlSignWithPlurio: prefix + '/Certificate/SignWithPlurio',

  },

  ia: {

    urlGetDocumentChat: prefix + '/Ai/GetDocumentChat',
    urlDocumentChat: prefix + '/Ai/DocumentChat',
    urlGetConfiguration: prefix + '/Ai/GetConfiguration',
    urlUpdateConfiguration: prefix + '/Ai/UpdateConfiguration',

    urlOracleChat: prefix + '/Ai/OracleChat',

  },

  eletronicSignature: {

    urlGetRequestByDocumentId: prefix + '/EletronicSignature/GetRequestByDocumentId',
    urlGetRequestDetail: prefix + '/EletronicSignature/GetRequestDetail',

    urlGetCreateRequest: prefix + '/EletronicSignature/GetCreateRequest',
    urlCreateRequest: prefix + '/EletronicSignature/CreateRequest',
    urlGetPositionSignatures: prefix + '/EletronicSignature/GetPositionSignatures',


  },

  workflow: {

    urlGetWorkflowsExecute: prefix + '/Workflow/GetWorkflowsExecute',
    urlGetStartNewWorkflow: prefix + '/Workflow/GetStartNewWorkflow',
    urlGetStartNewWorkflowSpecs: prefix + '/Workflow/GetStartNewWorkflowSpecs',
    urlStartNewWorkflowSpecs: prefix + '/Workflow/StartNewWorkflowSpecs',
    urlGetWorkflowExecuteDetails: prefix + '/Workflow/GetWorkflowExecuteDetails',

  },

  documentEditor: {

    urlGetExcelEditor: prefix + '/DocumentEditor/GetExcelEditor',
    urlGetExcelWorkbook: prefix + '/DocumentEditor/GetExcelWorkbook',
    urlSaveExcelWorkbook: prefix + '/DocumentEditor/SaveExcelWorkbook',

    urlGetWordEditor: prefix + '/DocumentEditor/GetWordEditor',
    urlGetWordContainer: prefix + '/DocumentEditor/GetWordContainer',
    urlSaveWordContainer: prefix + '/DocumentEditor/SaveWordContainer',

  },

  viewer: {

    urlGetPageThumb:  prefix + '/Viewer/GetPageThumb',
    urlGetPageAsPDFFile: prefix + '/Viewer/GetPageAsPDFFile',
    urlGetPageFile: prefix + '/Viewer/GetPageFile',
    urlGetViewSummary: prefix + '/Viewer/GetViewSummary',
    urlGetViewPermissions: prefix + '/Viewer/GetViewPermissions',
    urlConvertPageAsPDFFile: prefix + '/Viewer/ConvertPageAsPDFFile',

  },


  // LEGACY

  homeUrls: {

    urlIndex: prefix
  },

  jsTreeUrls: {
    urlGetRoots: prefix + '/Tree/GetTree',
    urlGetWardrobe: prefix + '/Tree/GetTreeArmario',
    urlGetFolder: prefix + '/Tree/GetTreePasta',
  },

  gridUrls: {
    urlGetGridWardrobePrincipal: prefix + '/Grid/GetGridTableWardrobePrincipal',
    urlGetGridFolderPrincipal: prefix + '/Grid/GetGridTableFolderPrincipal',
    urlGetGridTableFichaSearch: prefix + '/Grid/GetGridTableFichaSearch',
    urlGetGridTableDocumentoSearch: prefix + '/Grid/GetGridTableDocumentoSearch',
    urlGetGridTableOCRSearch: prefix + '/Grid/GetGridTableOCRSearch',
    urlExportFromFichaSearch: prefix + '/Grid/ExportFromFichaSearch',
    urlGetExportOptions: prefix + '/Grid/GetExportOptions',
    urlGetFichaSearchReportOptions: prefix + '/Grid/GetFichaSearchReportOptions',
    urlGetFichaSearchReport: prefix + '/Grid/GetFichaSearchReport',
    urlGetDocumentSearchReportOptions: prefix + '/Grid/GetDocumentSearchReportOptions',
    urlGetDocumentSearchReport: prefix + '/Grid/GetDocumentSearchReport',
    urlGetOCRSearchReportOptions: prefix + '/Grid/GetOCRSearchReportOptions',
    urlGetOCRSearchReport: prefix + '/Grid/GetOCRSearchReport',
  },

  armarioUrls: {

    urlGetArmario: prefix + '/Armario/GetArmario',
    urlGetArmarios: prefix + '/Armario/GetArmarios',
    urlGetCreateFolder: prefix + '/Armario/GetCreateFolder',
    urlCreateFolder: prefix + '/Armario/CreateFolder',
    urlGetCreate: prefix + '/Armario/GetCreate',
    urlCreate: prefix + '/Armario/Create',
    urlDelete: prefix + '/Armario/Delete',
    urlGetRename: prefix + '/Armario/GetRename',
    urlRename: prefix + '/Armario/Rename',
    urlGetManagerRoles: prefix + '/Armario/GetManagerRoles',
    urlManagerRoles: prefix + '/Armario/ManagerRoles',
    urlGetObjectRoles: prefix + '/Armario/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Armario/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Armario/GetProperties',
    urlGetPermissions: prefix + '/Armario/GetPermissions',
    urlGetHistory: prefix + '/Armario/GetHistory',
    urlGetAuditAccess: prefix + '/Armario/GetAuditAccess',

  },

  pastaUrls: {

    urlGetCreate: prefix + '/Pasta/GetCreate',
    urlCreate: prefix + '/Pasta/Create',
    urlGetRename: prefix + '/Pasta/GetRename',
    urlRename: prefix + '/Pasta/Rename',
    urlGetDelete: prefix + '/Pasta/GetDelete',
    urlDelete: prefix + '/Pasta/Delete',
    urlGetManagerRoles: prefix + '/Pasta/GetManagerRoles',
    urlManagerRoles: prefix + '/Pasta/ManagerRoles',
    urlGetObjectRoles: prefix + '/Pasta/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Pasta/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Pasta/GetProperties',
    urlGetPermissions: prefix + '/Pasta/GetPermissions',
    urlGetDocumentsForSignInFolder: prefix + '/Pasta/GetDocumentsForSignInFolder',
    urlGetAttribForm: prefix + '/Pasta/GetAttribForm',
    urlAttribFormDataDocuments: prefix + '/Pasta/AttribFormDataDocuments',
    urlAttribFormData: prefix + '/Pasta/AttribFormData',
    urlGetFormData: prefix + '/Pasta/GetFormData',
    urlProcessOCR: prefix + '/Pasta/ProcessOCR',
    urlGetName: prefix + '/Pasta/GetName',
    urlGetCopyTo: prefix + '/Pasta/GetCopyTo',
    urlGetCopyToDragAndDrop: prefix + '/Pasta/GetCopyToDragAndDrop',
    urlCopyTo: prefix + '/Pasta/CopyTo',
    urlGetCopyToWardrobeDragAndDrop: prefix + '/Pasta/GetCopyToWardrobeDragAndDrop',
    urlCopyToWardrobe: prefix + '/Pasta/CopyToWardrobe',
    urlGetMoveTo: prefix + '/Pasta/GetMoveTo',
    urlGetMoveToDragAndDrop: prefix + '/Pasta/GetMoveToDragAndDrop',
    urlMoveTo: prefix + '/Pasta/MoveTo',
    urlGetMoveToWardrobeDragAndDrop: prefix + '/Pasta/GetMoveToWardrobeDragAndDrop',
    urlMoveToWardrobe: prefix + '/Pasta/MoveToWardrobe',
    urlGetSign: prefix + '/Pasta/GetSign',
    urlGetHistory: prefix + '/Pasta/GetHistory',
    urlGetPropertiesDocsWithotPages: prefix + '/Pasta/GetPropertiesDocsWithotPages',
    urlGetProcessOCR: prefix + '/Pasta/GetProcessOCR',
    urlGetPastaMonitorEmailConfigs: prefix + '/Pasta/GetPastaMonitorEmailConfigs',
    urlGetPropertiesDocsMonitor: prefix + '/Pasta/GetPropertiesDocsMonitor',
    urlDeletePastaMonitorEmail: prefix + '/Pasta/DeletePastaMonitorEmail',
    urlCreatePastaMonitorEmail: prefix + '/Pasta/CreatePastaMonitorEmail',
    urlUnlockDocuments: prefix + '/Pasta/UnlockDocuments',
    urlGetTreePath: prefix + '/Pasta/GetTreePath',
    urlGetAuditAccess: prefix + '/Pasta/GetAuditAccess',
    urlGetMoveToMultiple: prefix + '/Pasta/GetMoveToMultiple',
    urlGetTreePathById: prefix + '/Pasta/GetTreePathById',
    urlGetCopyToMultiple: prefix + '/Pasta/GetCopyToMultiple',
    urlGetProcessOCRMultiple: prefix + '/Pasta/GetProcessOCRMultiple',
    urlProcessOCRMultiple: prefix + '/Pasta/ProcessOCRMultiple',
    urlGetMergeToMultiple: prefix + '/Pasta/GetMergeToMultiple',
    urlMergeToMultiple: prefix + '/Pasta/MergeToMultiple',
    urlGetVirtualPath: prefix + '/Pasta/GetVirtualPath',

  },

  documentoUrls: {

    urlGetRename: prefix + '/Documento/GetRename',
    urlRename: prefix + '/Documento/Rename',
    urlDelete: prefix + '/Documento/Delete',
    urlGetExport: prefix + '/Documento/GetExport',
    urlExport: prefix + '/Documento/Export',
    urlGetManagerRoles: prefix + '/Documento/GetManagerRoles',
    urlGetObjectRoles: prefix + '/Documento/GetObjectRoles',
    urlGetObjectRolesAccess: prefix + '/Documento/GetObjectRolesAccess',
    urlGetProperties: prefix + '/Documento/GetProperties',
    urlGetCopyTo: prefix + '/Documento/GetCopyTo',
    urlCopyTo: prefix + '/Documento/CopyTo',
    urlGetImportTo: prefix + '/Documento/GetImportTo',
    urlGetPrintablePages: prefix + '/Documento/GetPrintablePages',
    urlUnblock: prefix + '/Documento/Unblock',
    urlProcessOCR: prefix + '/Documento/ProcessOCR',
    urlGetDocumentThumb: prefix + '/Documento/GetDocumentThumb',
    urlGetPermissions: prefix + '/Documento/GetPermissions',
    urlGetTrechosOCR: prefix + '/Documento/GetTrechosOCR',
    urlGetViewSummary: prefix + '/Documento/GetViewSummary',
    urlGetFormData: prefix + '/Documento/GetFormData',
    urlGetCreate: prefix + '/Documento/GetCreate',
    urlCreate: prefix + '/Documento/Create',
    urlGetDocumento: prefix + '/Documento/GetDocumento',
    urlManagerRoles: prefix + '/Documento/ManagerRoles',
    urlGetEditForm: prefix + '/Documento/GetEditForm',
    urlEditForm: prefix + '/Documento/EditForm',
    urlGetPrintForm: prefix + '/Documento/GetPrintForm',
    urlGetPrintFormData: prefix + '/Documento/GetPrintFormData',
    urlGetReplace: prefix + '/Documento/GetReplace',
    urlGetCopyToDragAndDrop: prefix + '/Documento/GetCopyToDragAndDrop',
    urlGetMoveTo: prefix + '/Documento/GetMoveTo',
    urlGetMoveToDragAndDrop: prefix + '/Documento/GetMoveToDragAndDrop',
    urlMoveTo: prefix + '/Documento/MoveTo',
    urlGetTemporalidade: prefix + '/Documento/GetTemporalidade',
    urlTemporalidade: prefix + '/Documento/Temporalidade',
    urlGetSign: prefix + '/Documento/GetSign',
    urlStartSign: prefix + '/Documento/StartSign',
    //urlStartSignPAdES: prefix + '/Documento/StartSignPAdES',
    urlFinishSign: prefix + '/Documento/FinishSign',
    //urlFinishSignPAdES: prefix + '/Documento/FinishSignPAdES',
    urlRemoveSign: prefix + '/Documento/RemoveSign',
    urlGetMarcaDagua: prefix + '/Documento/GetMarcaDagua',
    urlMarcaDagua: prefix + '/Documento/MarcaDagua',
    urlGetCreateFromPageClassify: prefix + '/Documento/GetCreateFromPageClassify',
    urlMovePagesToDocument: prefix + '/Documento/MovePagesToDocument',
    urlCopyPagesToDocument: prefix + '/Documento/CopyPagesToDocument',
    urlGetCopyMoveFromPageClassify: prefix + '/Documento/GetCopyMoveFromPageClassify',
    urlGetHistory: prefix + '/Documento/GetHistory',
    urlGetShare: prefix + '/Documento/GetShare',
    urlShare: prefix + '/Documento/Share',
    urlDeleteShare: prefix + '/Documento/DeleteShare',
    urlGetTotalPages: prefix + '/Documento/GetTotalPages',
    urlGetProcessOCR: prefix + '/Documento/GetProcessOCR',
    urlGetTreePath: prefix + '/Documento/GetTreePath',
    urlMergeTo: prefix + '/Documento/MergeTo',
    urlGetAuditAccess: prefix + '/Documento/GetAuditAccess',
    urlSplitPDF: prefix + '/Documento/SplitPDF',
    urlProcessOCRMultiple: prefix + '/Documento/ProcessOCRMultiple',
    urlGetSignMultiple: prefix + '/Documento/GetSignMultiple',
    urlGetTemporalidadeMultiple: prefix + '/Documento/GetTemporalidadeMultiple',
    urlTemporalidadeMultiple: prefix + '/Documento/TemporalidadeMultiple',
    urlGetMergeToMultiple: prefix + '/Documento/GetMergeToMultiple',
    urlGetEditFormMultiple: prefix + '/Documento/GetEditFormMultiple',
    urlEditFormMultiple: prefix + '/Documento/EditFormMultiple',


    urlCreateByProfileAsync: prefix + '/Documento/CreateByProfile',
    urlCreateByFolderIdAsync: prefix + '/Documento/CreateByFolderId',
    urlImportToAsync: prefix + '/Documento/ImportTo',
    urlGetWebTreePath: prefix + '/Documento/GetWebTreePath',

    urlCreateFromClassifyAsync: prefix + '/Documento/CreateFromClassify',

    urlGetConvertDocument: prefix + '/Documento/GetConvertDocument',
    urlConvertDocument: prefix + '/Documento/ConvertDocument',
    urlGetCreateMultiple: prefix + '/Documento/GetCreateMultiple',

    urlCreateDocRequestByProfileAsync: prefix + '/Documento/CreateDocRequestByProfile',
  },

  paginaUrls: {

    urlGetOCR: prefix + '/Pagina/GetOCR',
    urlGetPageFileName: prefix + '/Pagina/GetPageFileName',
    urlUploadFile: prefix + '/Pagina/UploadFile',
    urlProcessOCR: prefix + '/Pagina/ProcessOCR',
    urlSaveOCR: prefix + '/Pagina/SaveOCR',
    urlGetMovePage: prefix + '/Pagina/GetMovePage',
    urlMovePage: prefix + '/Pagina/MovePage',
    urlDelete: prefix + '/Pagina/Delete',
    urlGetBase64ForSign: prefix + '/Pagina/GetBase64ForSign',
    urlSaveSignature: prefix + '/Pagina/SaveSignature',
    urlRotatePage: prefix + '/Pagina/RotatePage',
    urlGetPageFile: prefix + '/Pagina/GetPageFile',
    urlGetPageThumb: prefix + '/Pagina/GetPageThumb',
    urlGetAnnotation: prefix + '/Pagina/GetAnnotation',
    urlGetCreateAnnotation: prefix + '/Pagina/GetCreateAnnotation',
    urlCreateAnnotation: prefix + '/Pagina/CreateAnnotation',
    urlDeleteAnnotation: prefix + '/Pagina/DeleteAnnotation',
    urlSaveMarcacao: prefix + '/Pagina/SaveMarcacao',
    urlRemoveMarcacao: prefix + '/Pagina/RemoveMarcacao',
    urlGetMarcacoes: prefix + '/Pagina/GetMarcacoes',
    urlCanViewWithouMarcacao: prefix + '/Pagina/CanViewWithouMarcacao',
    urlGetBigThumb: prefix + '/Pagina/GetBigThumb',
    urlLogActivityDownload: prefix + '/Pagina/LogActivityDownload',
    urlLogActivityPrint: prefix + '/Pagina/LogActivityPrint',
    urlGetPageFileOfficePre: prefix + '/Pagina/GetPageFileOfficePre',
    urlGetPageFileOffice: prefix + '/Pagina/GetPageFileOffice'

  },

  imagensUrls: {

    urlLogoLiquidSuiteMedio: prefix + '/images/logotipo_med.png',
    urlLogoLiquidSuite: prefix + '/images/logotipo_pequeno.png',
    urlInfoIcon: prefix + '/images/ic_info_white_24px.svg',
    urlMisteryMan: prefix + '/images/mistery-man.png',
    urlMisteryMan120: prefix + '/images/mistery-man-120.png'

  },

  usuarioUrls: {

    urlGetUserName: prefix + '/Usuario/GetUserName',
    urlGetGravatarUrl: prefix + '/Usuario/GetGravatarUrl',
    urlLogout: prefix + '/Login/LogOut',
    urlGetUsuario: prefix + '/Usuario/GetUsuario',
    urlGetUsuarios: prefix + '/Usuario/GetUsuarios',
    urlGetObjectRoles: prefix + '/Usuario/GetObjectRoles',
    urlGetSystemRoles: prefix + '/Usuario/GetSystemRoles',
    urlGetCreate: prefix + '/Usuario/GetCreate',
    urlCreate: prefix + '/Usuario/Create',
    urlGetEdit: prefix + '/Usuario/GetEdit',
    urlEdit: prefix + '/Usuario/Edit',
    urlDelete: prefix + '/Usuario/Delete',
    urlGetManagerRoles: prefix + '/Usuario/GetManagerRoles',
    urlManagerRoles: prefix + '/Usuario/ManagerRoles',
    urlGetManagerSystemRoles: prefix + '/Usuario/GetManagerSystemRoles',
    urlManagerSystemRoles: prefix + '/Usuario/ManagerSystemRoles',
    // urlGetAllUsuarios: prefix + '/Usuario/GetAllUsuarios',
    urlGetUsuariosForReports: prefix + '/Usuario/GetUsuariosForReports',
    urlGetSystemPermission: prefix + '/Usuario/GetSystemPermission',
    urlGetUpdatePassword: prefix + '/Usuario/GetUpdatePassword',
    urlUpdatePassword: prefix + '/Usuario/UpdatePassword',
    urlGetEditPerfil: prefix + '/Usuario/GetEditPerfil',
    urlEditPerfil: prefix + '/Usuario/EditPerfil',
    urlUploadFile: prefix + '/Usuario/UploadFile',
    urlGetImagemPerfil: prefix + '/Usuario/GetImagemPerfil',
    urlUpdateResetPassword: prefix + '/Usuario/UpdateResetPassword',
    urlGetActiveSessions: prefix + '/Usuario/GetActiveSessions',
    urlGetActiveSessionDetails: prefix + '/Usuario/GetActiveSessionDetails',
    urlDeleteActiveSession: prefix + '/Usuario/DeleteActiveSession',
    urlGetCreateNotification: prefix + '/Usuario/GetCreateNotification',
    urlGetMessages: prefix + '/Usuario/GetMessages',
    urlCreateNotification: prefix + '/Usuario/CreateNotification',
    urlMarkMensagemAsRead: prefix + '/Usuario/MarkMensagemAsRead',
    urlRemoveMessages: prefix + '/Usuario/RemoveMessages',
    urlGetNewMessages: prefix + '/Usuario/GetNewMessages',
    urlGetHistory: prefix + '/Usuario/GetHistory',
    urlGetConfigureRootFolder: prefix + '/Usuario/GetConfigureRootFolder',
    urlConfigureRootFolder: prefix + '/Usuario/ConfigureRootFolder',
    urlGetUserProfile: prefix + '/Usuario/GetUserProfile',
    urlGetConfigAllowedApp: prefix + '/Usuario/GetConfigAllowedApp',
    urlConfigAllowedApp: prefix + '/Usuario/ConfigAllowedApp',

  },

  searchUrls: {

    urlGetSearch: prefix + '/Search/GetSearch'

  },

  reportUrls: {

    urlGetReportAtividades: prefix + '/Report/GetReportAtividades',
    urlReportAtividades: prefix + '/Report/ReportAtividades',
    urlGetTotalUsersOnline: prefix + '/Report/GetTotalUsersOnline',
    urlGetLastDocsAdd: prefix + '/Report/GetLastDocsAdd',
    urlGetLastPagesAdd: prefix + '/Report/GetLastPagesAdd',
    urlGetLastPagesViews: prefix + '/Report/GetLastPagesViews',
    urlGetVolumesInfo: prefix + '/Report/GetVolumesInfo',
    urlGetDatabaseSizeInfo: prefix + '/Report/GetDatabaseSizeInfo',
    urlGetFichasInfo: prefix + '/Report/GetFichasInfo',
    urlGetSystemInfoReport: prefix + '/Report/GetSystemInfoReport',
    urlGetReportError: prefix + '/Report/GetReportError',
    urlGetErrorDetail: prefix + '/Report/GetErrorDetail',
    urlGetActivityDetail: prefix + '/Report/GetActivityDetail',
    urlGetGridReportErrorForPrint: prefix + '/Report/GetGridReportErrorForPrint',
    urlGetPrintError: prefix + '/Report/GetPrintError',
    urlClearAll: prefix + '/Report/ClearAll',
    urlGetPrintActivities: prefix + '/Report/GetPrintActivities',
    urlReportAtividadesForPrint: prefix + '/Report/ReportAtividadesForPrint',
    urlGetReportProcessOCR: prefix + '/Report/GetReportProcessOCR',
    urlGetReportProcessOCRDetail: prefix + '/Report/GetReportProcessOCRDetail',
    urlCancelProcessOCRSchedule: prefix + '/Report/CancelProcessOCRSchedule',

    urlGetGridDocumentsExpired: prefix + '/Report/GetGridDocumentsExpired',
    urlGetGridDocumentsToExpire: prefix + '/Report/GetGridDocumentsToExpire',
    urlGetPrintTemporalidadeReport: prefix + '/Report/GetPrintTemporalidadeReport',

    urlGetGridUserGroupRules: prefix + '/Report/GetGridUserGroupRules',

    urlGetPrintUserGroupRulesReport: prefix + '/Report/GetPrintUserGroupRulesReport',

  },

  fichaUrls: {

    // urlGetFicha: prefix + '/Ficha/GetFicha',
    urlGetFichas: prefix + '/Ficha/GetFichas',
    // urlGetFichasOptimized: prefix + '/Ficha/GetFichasOptimized',
    // urlGetFichasForWebImport: prefix + '/Ficha/GetFichasForWebImport',
    // urlGetDescription: prefix + '/Ficha/GetDescription',
    urlGetFichasWithCampos: prefix + '/Ficha/GetFichasWithCampos',

    urlGetCreate: prefix + '/Ficha/GetCreate',
    urlCreate: prefix + '/Ficha/Create',
    urlGetEdit: prefix + '/Ficha/GetEdit',
    urlEdit: prefix + '/Ficha/Edit',
    urlDelete: prefix + '/Ficha/Delete',
    urlGetObjectRoles: prefix + '/Ficha/GetObjectRoles',
    urlGetManagerRoles: prefix + '/Ficha/GetManagerRoles',
    urlManagerRoles: prefix + '/Ficha/ManagerRoles',
    urlGetCamposByFicha: prefix + '/Ficha/GetCamposByFicha',
    urlGetCampoCreate: prefix + '/Ficha/GetCampoCreate',
    urlCampoCreate: prefix + '/Ficha/CampoCreate',
    urlGetCampoEdit: prefix + '/Ficha/GetCampoEdit',
    urlCampoEdit: prefix + '/Ficha/CampoEdit',
    urlCampoDelete: prefix + '/Ficha/CampoDelete',
    urlGetConfigIndexDesktop: prefix + '/Ficha/GetConfigIndexDesktop',
    urlConfigIndexDesktop: prefix + '/Ficha/ConfigIndexDesktop',
    urlGetTemporalidade: prefix + '/Ficha/GetTemporalidade',
    urlTemporalidade: prefix + '/Ficha/Temporalidade',
    urlGetHistory: prefix + '/Ficha/GetHistory',
    urlGetFichasForReports: prefix + '/Ficha/GetFichasForReports',
  },

  perfilImportacaoUrls: {

    urlGetPerfisImportacao: prefix + '/PerfilImportacao/GetPerfisImportacao',

    // urlGetPerfilImportacao: prefix + '/PerfilImportacao/GetPerfilImportacao',
    // urlGetPerfisImportacaoOptimized: prefix + '/PerfilImportacao/GetPerfisImportacaoOptimized',
    // urlGetDescription: prefix + '/PerfilImportacao/GetDescription',
    // urlGetPerfisImportacaoForWebImport: prefix + '/PerfilImportacao/GetPerfisImportacaoForWebImport',

    urlGetCreate: prefix + '/PerfilImportacao/GetCreate',
    urlCreate: prefix + '/PerfilImportacao/Create',
    urlGetEdit: prefix + '/PerfilImportacao/GetEdit',
    urlEdit: prefix + '/PerfilImportacao/Edit',
    urlDelete: prefix + '/PerfilImportacao/Delete',

    urlGetHistory: prefix + '/PerfilImportacao/GetHistory'

  },

  volumeUrls: {

    urlGetVolume: prefix + '/Volume/GetVolume',
    urlGetVolumes: prefix + '/Volume/GetVolumes',
    urlGetCreate: prefix + '/Volume/GetCreate',
    urlCreate: prefix + '/Volume/Create',
    urlCreateGoogleDrive: prefix + '/Volume/CreateGoogleDrive',
    urlGetEdit: prefix + '/Volume/GetEdit',
    urlEdit: prefix + '/Volume/Edit',
    urlDelete: prefix + '/Volume/Delete',
    urlGetHistory: prefix + '/Volume/GetHistory',
    urlGetUpdateCredentials: prefix + '/Volume/GetUpdateCredentials',
    urlUpdateCredentials: prefix + '/Volume/UpdateCredentials',
    // urlDeleteTrashBin: prefix + '/Volume/DeleteTrashBin',
    urlGetVolumeInfo: prefix + '/Volume/GetVolumeInfo',
    urlSetDefault: prefix + '/Volume/SetDefault',

  },

  grupoUrls: {

    urlGetGrupo: prefix + '/Grupo/GetGrupo',
    urlGetGrupos: prefix + '/Grupo/GetGrupos',
    urlGetCreate: prefix + '/Grupo/GetCreate',
    urlCreate: prefix + '/Grupo/Create',
    urlGetEdit: prefix + '/Grupo/GetEdit',
    urlEdit: prefix + '/Grupo/Edit',
    urlDelete: prefix + '/Grupo/Delete',
    urlGetManagerRoles: prefix + '/Grupo/GetManagerRoles',
    urlManagerRoles: prefix + '/Grupo/ManagerRoles',
    urlGetObjectRoles: prefix + '/Grupo/GetObjectRoles',
    urlGetSystemRoles: prefix + '/Grupo/GetSystemRoles',
    urlGetManagerSystemRoles: prefix + '/Grupo/GetManagerSystemRoles',
    urlManagerSystemRoles: prefix + '/Grupo/ManagerSystemRoles',
    urlGetUsuarios: prefix + '/Grupo/GetUsuarios',
    // urlGetSubGrupos: prefix + '/Grupo/GetSubGrupos',
    urlGetUsuariosView: prefix + '/Grupo/GetUsuariosView',
    // urlGetSubGruposView: prefix + '/Grupo/GetSubGruposView',
    urlGetHistory: prefix + '/Grupo/GetHistory',
    urlGetConfigAllowedApp: prefix + '/Grupo/GetConfigAllowedApp',
    urlConfigAllowedApp: prefix + '/Grupo/ConfigAllowedApp',

    urlGetGruposForReports: prefix + '/Grupo/GetGruposForReports',

  },

  objectRolesUrls: {

    urlGetObjectRoles: prefix + '/ObjectRole/GetObjectRoles',
    urlGetObjectRole: prefix + '/ObjectRole/GetObjectRole',
    urlGetCreate: prefix + '/ObjectRole/GetCreate',
    urlCreate: prefix + '/ObjectRole/Create',
    urlGetEdit: prefix + '/ObjectRole/GetEdit',
    urlEdit: prefix + '/ObjectRole/Edit',
    urlDelete: prefix + '/ObjectRole/Delete',
    urlGetHistory: prefix + '/ObjectRole/GetHistory'

  },

  systemRolesUrls: {

    urlGetSystemRoles: prefix + '/SystemRole/GetSystemRoles',
    urlGetSystemRole: prefix + '/SystemRole/GetSystemRole',
    urlGetCreate: prefix + '/SystemRole/GetCreate',
    urlCreate: prefix + '/SystemRole/Create',
    urlGetEdit: prefix + '/SystemRole/GetEdit',
    urlEdit: prefix + '/SystemRole/Edit',
    urlDelete: prefix + '/SystemRole/Delete',
    urlGetCanAccessManager: prefix + '/SystemRole/GetCanAccessManager',
    urlGetCanSearch: prefix + '/SystemRole/GetCanSearch',
    urlGetCanAccessReports: prefix + '/SystemRole/GetCanAccessReports',
    urlGetHistory: prefix + '/SystemRole/GetHistory'

  },

  logImportacaoUrls: {

    urlGetGuid: prefix + '/LogImportacao/GetGuid'
  },

  cssUrls: {

    urlBootstrapCss: prefix + '/lib/bootstrap/dist/css/bootstrap.min.css',
    urlRobotoFontCss: 'https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i'
  },

  conexaoUrls: {

    urlGetConexao: prefix + '/Conexao/GetConexao',
    urlGetConexoes: prefix + '/Conexao/GetConexoes',
    urlGetCreate: prefix + '/Conexao/GetCreate',
    urlCreate: prefix + '/Conexao/Create',
    urlGetEdit: prefix + '/Conexao/GetEdit',
    urlEdit: prefix + '/Conexao/Edit',
    urlDelete: prefix + '/Conexao/Delete',
    urlGetHistory: prefix + '/Conexao/GetHistory'
  },

  queryUrls: {

    // urlGetQuery: prefix + '/Query/GetQuery',
    urlGetQueries: prefix + '/Query/GetQueries',
    urlGetCreate: prefix + '/Query/GetCreate',
    urlCreate: prefix + '/Query/Create',
    urlGetEdit: prefix + '/Query/GetEdit',
    urlEdit: prefix + '/Query/Edit',
    urlDelete: prefix + '/Query/Delete',
    urlGetHistory: prefix + '/Query/GetHistory'
  },

  integracaoUrls: {

    urlGetIntegracao: prefix + '/Integracao/GetIntegracao',
    urlGetIntegracoes: prefix + '/Integracao/GetIntegracoes',
    urlGetCreate: prefix + '/Integracao/GetCreate',
    urlCreate: prefix + '/Integracao/Create',
    urlGetEdit: prefix + '/Integracao/GetEdit',
    urlEdit: prefix + '/Integracao/Edit',
    urlDelete: prefix + '/Integracao/Delete',

    urlCallIntegracao: prefix + '/Integracao/CallIntegracao',
    urlGetHistory: prefix + '/Integracao/GetHistory'
  },

  indexadorUrls: {

    urlGetDynamicWebTwain: prefix + '/Indexador/GetDynamicWebTwain',
    urlGetCreate: prefix + '/Indexador/GetCreate',
    urlUploadProcess: prefix + '/Indexador/UploadProcess',
    urlUploadFile: prefix + '/Indexador/UploadFile',
    urlImportProcess: prefix + '/Indexador/ImportProcess',
    urlGetIsLicenced: prefix + '/Indexador/GetIsLicenced'
  },

  authApplicationsUrls: {

    urlGetAuthApplications: prefix + '/AuthApplication/GetAuthApplications',
    urlGetAuthApplication: prefix + '/AuthApplication/GetAuthApplication',
    urlGetCreate: prefix + '/AuthApplication/GetCreate',
    urlCreate: prefix + '/AuthApplication/Create',
    urlGetEdit: prefix + '/AuthApplication/GetEdit',
    urlEdit: prefix + '/AuthApplication/Edit',
    urlDelete: prefix + '/AuthApplication/Delete',
    urlGetHistory: prefix + '/AuthApplication/GetHistory',
    urlGetGroupUserAllowed: prefix + '/AuthApplication/GetGroupUserAllowed',
    urlGroupUserAllowed: prefix + '/AuthApplication/GroupUserAllowed',
  },

  configuradorUrls: {

    urlGetLiquidSuiteEmailConfig: prefix + '/Configurador/GetLiquidSuiteEmailConfig',
    urlEditLiquidSuiteEmailConfig: prefix + '/Configurador/EditLiquidSuiteEmailConfig',

    urlGetLiquidSuiteSecurityConfig: prefix + '/Configurador/GetLiquidSuiteSecurityConfig',
    urlEditLiquidSuiteSecurityConfig: prefix + '/Configurador/EditLiquidSuiteSecurityConfig',

    urlGetConfigLiquidSuite: prefix + '/Configurador/GetConfigLiquidSuite',
    //urlGetEditLiquidSuiteConfig: prefix + '/Configurador/GetEditLiquidSuiteConfig',
    //urlEditLiquidSuiteConfig: prefix + '/Configurador/EditLiquidSuiteConfig',
    //urlGetConfigTemporalidade: prefix + '/Configurador/GetConfigTemporalidade',
    //urlStartTemporalidadeService: prefix + '/Configurador/StartTemporalidadeService',
    //urlStopTemporalidadeService: prefix + '/Configurador/StopTemporalidadeService',
    urlGetHistory: prefix + '/Configurador/GetHistory',
    //urlGetConfigActiveDirectory: prefix + '/Configurador/GetConfigActiveDirectory',
    urlGetUsersActiveDirectory: prefix + '/Configurador/GetUsersActiveDirectory',
    urlImportUsersActiveDirectory: prefix + '/Configurador/ImportUsersActiveDirectory',
    //urlEditConfigActiveDirectory: prefix + '/Configurador/EditConfigActiveDirectory',
    urlGetConfigCertification: prefix + '/Configurador/GetConfigCertification',
    urlEditConfigCertification: prefix + '/Configurador/EditConfigCertification',

    urlGetViewLDAPConfigurations: prefix + '/Configurador/GetViewLDAPConfigurations',
    urlGetViewLDAPConfiguration: prefix + '/Configurador/GetViewLDAPConfiguration',
    urlEditLDAPConfiguration: prefix + '/Configurador/EditLDAPConfiguration',
    urlGetViewNewLDAPConfiguration: prefix + '/Configurador/GetViewNewLDAPConfiguration',
    urlCreateLDAPConfiguration: prefix + '/Configurador/CreateLDAPConfiguration',
    urlDeleteLDAPConfiguration: prefix + '/Configurador/DeleteLDAPConfiguration',


  },

  marcaDaguaUrls: {

    urlGetMarcaDagua: prefix + '/MarcaDagua/GetMarcaDagua',
    urlGetMarcasDagua: prefix + '/MarcaDagua/GetMarcasDagua',
    urlGetCreate: prefix + '/MarcaDagua/GetCreate',
    urlCreate: prefix + '/MarcaDagua/Create',
    urlGetEdit: prefix + '/MarcaDagua/GetEdit',
    urlEdit: prefix + '/MarcaDagua/Edit',
    urlDelete: prefix + '/MarcaDagua/Delete',
    urlGetHistory: prefix + '/MarcaDagua/GetHistory'
  },

  helperUrls: {

    urlGetVideos: prefix + '/Helper/GetVideos'

  },

  campoUrls: {

    urlGetAutoFill: prefix + '/Campo/GetAutoFill',
    urlAutoFill: prefix + '/Campo/AutoFill',
    urlGetFormatFrontEnd: prefix + '/Campo/GetFormatFrontEnd',
    urlFormatFrontEnd: prefix + '/Campo/FormatFrontEnd',
    urlGetFormatBackEnd: prefix + '/Campo/GetFormatBackEnd',
    urlFormatBackEnd: prefix + '/Campo/FormatBackEnd',

    urlGetActiveIntegracao: prefix + '/Campo/GetActiveIntegracao',
    urlActiveIntegracao: prefix + '/Campo/ActiveIntegracao',
    urlRemoveIntegracao: prefix + '/Campo/RemoveIntegracao',

    urlGetIndexacaoCampo: prefix + '/Campo/GetIndexacaoCampo',
    urlIndexacaoCampo: prefix + '/Campo/IndexacaoCampo',

  },

  licensesUrls: {

    urlGetEdit: prefix + '/Licenses/GetEdit',
    urlEdit: prefix + '/Licenses/Edit',
    urlGetClassifyDocumentEnabled: prefix + '/Licenses/GetClassifyDocumentEnabled',

  },

  queryAPIUrls: {

    // urlGet: prefix + '/QuerysAPI/Get',
    urlGetAll: prefix + '/QuerysAPI/GetAll',
    urlGetCreate: prefix + '/QuerysAPI/GetCreate',
    urlCreate: prefix + '/QuerysAPI/Create',
    urlGetEdit: prefix + '/QuerysAPI/GetEdit',
    urlEdit: prefix + '/QuerysAPI/Edit',
    urlDelete: prefix + '/QuerysAPI/Delete'
  },

  integrationAPIUrls: {

    urlGet: prefix + '/IntegracaoAPI/Get',
    urlGetAll: prefix + '/IntegracaoAPI/GetAll',
    urlGetCreate: prefix + '/IntegracaoAPI/GetCreate',
    urlCreate: prefix + '/IntegracaoAPI/Create',
    urlGetEdit: prefix + '/IntegracaoAPI/GetEdit',
    urlEdit: prefix + '/IntegracaoAPI/Edit',
    urlDelete: prefix + '/IntegracaoAPI/Delete',

    urlGetFieldsCondition: prefix + '/IntegracaoAPI/GetFieldsCondition',
    urlCallIntegracao: prefix + '/IntegracaoAPI/CallIntegracao',

  },

};

